module.exports = __webpack_public_path__ + "static/media/jamilBailonySmiling.9d396ae0.png";